// Which build is running, and on what.
//
// IS_MOBILE_BUILD is a BUILD-TIME flag (REACT_APP_TARGET=mobile), not a runtime
// check. It decides which router tree App.js pulls in, so the admin /
// resume-writer / marketing routes are never bundled into the app shipped to
// the App Store. That matters beyond bundle size: shipping role-gated admin
// screens invites a Guideline 2.3.1 "hidden features" rejection.
//
// The Capacitor helpers below ARE runtime checks - the mobile bundle also runs
// in a plain browser during `yarn start`, where no native layer exists.
import { Capacitor } from "@capacitor/core";

export const IS_MOBILE_BUILD = process.env.REACT_APP_TARGET === "mobile";

// True only inside the native shell. False in any browser, including when the
// mobile bundle is served by the dev server.
export const isNative = () => Capacitor.isNativePlatform();

export const getPlatform = () => Capacitor.getPlatform(); // "ios" | "android" | "web"

export const isIOS = () => Capacitor.getPlatform() === "ios";

export const isAndroid = () => Capacitor.getPlatform() === "android";
